import * as React from "react";

function Avatar({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full ${className}`}
      {...props}
    />
  );
}

function AvatarImage({ src, alt, className = 'h-full w-full object-cover', style }: { src?: string; alt?: string, className?: any, style?: any }) {
  return <div className="relative group inline-flex flex-start ">
    <img src={src} alt={alt} className={className} {...style} />
    <div
      className="absolute left-1/2 -translate-x-1/4 bottom-full mb-2
                                px-2 py-1 text-sm text-white bg-gray-500 rounded
                                opacity-0 group-hover:opacity-100 transition-opacity duration-200
                                whitespace-nowrap"
    >
      {alt}
    </div>
  </div>;
}

function AvatarFallback({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-full w-full items-center justify-center bg-gray-200 text-sm text-gray-600">
      {children}
    </div>
  );
}

export { Avatar, AvatarImage, AvatarFallback };
